import { createI18n } from 'vue-i18n';

/**
 * Load locale messages (Vite ESM).
 * Uses import.meta.glob to load all JSON files from locales.
 */
function loadLocaleMessages() {
  const modules = import.meta.glob('../locales/*.json', { eager: true });
  const messages = {};
  Object.keys(modules).forEach((path) => {
    const matched = path.match(/\/([A-Za-z0-9-_]+)\.json$/i);
    if (matched && matched[1]) {
      messages[matched[1]] = modules[path].default;
    }
  });
  return messages;
}

export default createI18n({
  locale: import.meta.env.VITE_I18N_LOCALE || 'en',
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
  globalInjection: true,
  messages: loadLocaleMessages(),
  legacy: false, // Use Vue 3 composition API
  allowComposition: true, // Allow composition API
});
